"use client";

import { useState } from "react";
import { useLanguage } from "@/i18n/LanguageContext";

interface SouthMiamiHeroProps {
  h1?: string;
  subhead?: string;
  zips?: string[];
}

export default function SouthMiamiHero({ h1, subhead, zips }: SouthMiamiHeroProps) {
  const { t, currentLang } = useLanguage();
  const [imgFailed, setImgFailed] = useState(false);

  return (
    <section className="relative h-[70vh] flex overflow-hidden">
      {/* LEFT 40% text */}
      <div className="w-full md:w-[40%] bg-white flex flex-col justify-center px-10 py-16">
        <p className="text-xs uppercase tracking-[0.3em] text-[#ea580c] mb-4 font-bold">
          {currentLang === "es" ? "REPARACI\u00D3N DE VENTANAS SOUTH MIAMI" : "SOUTH MIAMI WINDOW REPAIR"}
        </p>
        <h1 className="text-3xl md:text-4xl font-bold text-[#064e3b] mb-4 leading-tight">
          {h1 || t("southMiami.h1")}
        </h1>
        <p className="text-gray-600 text-sm leading-relaxed mb-6">
          {subhead || t("southMiami.subhead")}
        </p>
        {zips && zips.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-6">
            {zips.map((zip) => (
              <span key={zip} className="inline-flex items-center gap-1.5 bg-[#fefce8] text-[#064e3b] px-3 py-1.5 text-xs font-bold rounded-full border border-[#064e3b]/10">
                <i className="ri-map-pin-line" />
                {zip}
              </span>
            ))}
          </div>
        )}
        <a
          href="tel:+17863774452"
          className="inline-flex items-center gap-2 bg-[#ea580c] text-white px-6 py-3 text-sm font-bold uppercase tracking-wider hover:bg-[#c2410c] transition-colors whitespace-nowrap w-fit"
          style={{ borderRadius: "10px" }}
        >
          <i className="ri-phone-line" />
          {currentLang === "es" ? "Llame al (786) 377-4452" : "Call (786) 377-4452"}
        </a>
      </div>

      {/* RIGHT 60% image */}
      <div className="hidden md:block w-[60%] relative">
        {!imgFailed && (
          <img
            src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/99fc8a5541d3649740f2559ff75bc08e.jpeg"
            alt={currentLang === "es" ? "Reparaci\u00F3n de ventanas en South Miami" : "Window repair in South Miami"}
            className="absolute inset-0 w-full h-full object-cover"
            onError={() => setImgFailed(true)}
          />
        )}
        {imgFailed && (
          <div className="absolute inset-0 bg-[#064e3b]" />
        )}
      </div>
    </section>
  );
}